import React from 'react'
import { Show } from 'data/Show'
import clsx from 'clsx'
import { formatTime } from 'utils/date'
import moment from 'moment'
import { useStyles } from './styles'
import { isPaywallDisabled } from 'redux/slices/liveShow'
import { useSelector } from 'react-redux'

const ShowCard: React.FC<{ show: Show }> = ({ show }) => {
    const classes = useStyles()
    const disablePaywall = useSelector(isPaywallDisabled)

    return (
        <div className={classes.showCard}>
            <div className={classes.showCardContent}>
                <div>
                    <img className={classes.img} src={show.posterImg} alt="" />
                    {!disablePaywall && <h4 className={classes.title}>register here</h4>}
                    <h4 className={classes.showTitle}>{show.title}</h4>
                    <p className={classes.showDate}>
                        <span>{moment(show.startTime).format('MMM DD')}</span>
                        <span>{formatTime(show.startTime)}</span>
                    </p>
                    <p className={clsx(classes.showDate, classes.showLocation)}>Streaming on Novel</p>
                </div>
            </div>
            <div className={classes.showCardBorder} />
        </div>
    )
}

export default ShowCard
